module.exports = __webpack_public_path__ + "static/media/payment_pending.30de1243.png";